// extracted by mini-css-extract-plugin
export default {"lens-ui-font-definition":"Hjd2ZM5l50_irYYNZztw","lensUiFontDefinition":"Hjd2ZM5l50_irYYNZztw","sidebar":"hyOt1_qqluSw8JxNkIYj"};